import React, { PropsWithChildren } from "react";

const DashboardHeading = ({ children }: PropsWithChildren<{}>) => (
  <h2 className="mb-2 text-lg leading-6 font-medium text-gray-900">{children}</h2>
);

export default DashboardHeading;
